import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  TimePicker,
  Typography,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';

import {
  AddAttendanceHistory,
  EditAttendanceHistory,
} from '../../../redux/actions/InitiativeUsher';

const EditRecordModal = ({ show, Close, data, mode, fetchData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);

  const onFinish = async values => {
    if (mode === 'edit') {
      const response = await dispatch(
        EditAttendanceHistory(data.pk, {
          ...values,
          date: values.date.format('YYYY-MM-DD').toString(),
          check_in_time: values.check_in_time.format('HH:mm').toString(),
          check_out_time: values.check_out_time.format('HH:mm').toString(),
        }),
      );

      if (typeof response === 'string' && response.includes('Error'))
        setErrorMessage(response);
      else {
        setErrorMessage(null);
        navigate(0);
      }
    } else {
      const payload = {
        ...values,
        initiative_usher: data?.initiative_usher,
        date: values.check_in_time.format('YYYY-MM-DD'),
        check_in_time: values.check_in_time.format('HH:mm:ss'),
        check_out_time: values.check_out_time.format('HH:mm:ss'),
        checkout_date: values.check_out_time.format('YYYY-MM-DD'),
      };
      const response = await dispatch(AddAttendanceHistory(payload));
      if (typeof response === 'string' && response.includes('Error'))
        setErrorMessage(response);
      else {
        fetchData();
        Close();
        setErrorMessage(null);
        // navigate(0);
      }
    }
  };

  return (
    <Modal
      key={data.pk}
      title="Edit Attendance Record Form"
      footer={null}
      open={show}
      onCancel={Close}
      width="800px"
    >
      <Form onFinish={onFinish}>
        {errorMessage && <p className="text-error">{errorMessage}</p>}

        <Row gutter={[8, 8]}>
          <Col md={12} xs={24}>
            <Typography.Text style={{ margin: '20px 0px' }}>
              Date: {data.date}
            </Typography.Text>
          </Col>
        </Row>

        <Row gutter={[8, 8]}>
          <Col md={12} xs={24}>
            <Form.Item
              name="check_in_time"
              label="Check-in Time"
              rules={[{ required: true }]}
            >
              <TimePicker />
            </Form.Item>
          </Col>

          <Col md={12} xs={24}>
            <Form.Item
              name="check_out_time"
              label="Check-out Date Time"
              rules={[{ required: true }]}
            >
              {console.log(
                dayjs(
                  `${data.date || dayjs().format('DD/MM/YYYY')} 00:00:00`,
                  'DD/MM/YYYY HH:mm:ss', // input format
                ),
              )}
              <DatePicker
                minDate={data?.date ? dayjs(data.date, 'DD/MM/YYYY') : null}
                format="YYYY-MM-DD HH:mm:ss"
                defaultValue={dayjs(
                  `${data.date || dayjs().format('DD/MM/YYYY')} 00:00:00`,
                  'DD/MM/YYYY HH:mm:ss', // input format
                )}
                showTime={{
                  defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  use12Hours: true,
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[8, 8]}>
          <Col xs={24}>
            <Form.Item
              label="Comments"
              name="comments"
              initialValue={data.comments}
            >
              <TextArea showCount />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[8, 8]}>
          <Col xs={24}>
            <Button htmlType="submit">Submit</Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditRecordModal;
